<template>
	<div class="home-background">
		<div class="home-title">
			<div class="title-left">
				<img style="width: 28px; height: 26px;" src="@/assets/images/login/title_icon.png" />
				<span>수집데이터</span>
			</div>
		</div>
		<div class="search-content">
			<select class="list-select" v-model="searchCategory">
				<option value="">선택</option>
				<option value="참여자번호">참여자번호</option>
				<option value="참여자이름">참여자이름</option>
				<!-- <option value="데이터분류">데이터분류</option>
				<option value="상태">상태</option> -->
			</select>

			<label 
				class="label-date-picker hidden"
				:style="utils.isEmpty(items.informedConsentDt)? 'color: #ccc' : 'color: #090909'"
			>
				{{
					(
						getDateValue()
					) 
				}} 
				<i class="mx-icon">
					<i class="mx-icon-calendar">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
								<path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z">
								</path>
							</svg>
						</i>
					<i class="mx-icon-clear"
						@click="clearDate()"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
							<path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z">
							</path>
						</svg>
					</i>
				</i>
				<date-picker
					ref="date-picker"
					v-model="items.informedConsentDtTemp"
					value-type="format"
					format="YYYY-MM-DD"
					style="width: 0px; height: 0px; overflow: hidden;"
					v-validate="'required'"
					name="informedConsentDt"
					data-vv-as="Consent Date"
					confirm
				/>
			</label>
			<input
				type="text"
				class="input-crud"
				style="width: 240px;"
				v-model="searchText"
				@keyup="keyupHandler"
			/>
			<div class="search-btn" @click.stop="selectCollectList()">
				<img src="@/assets/images/home/search.png"/>
				검색
			</div>
		</div>
		<div class="home-bottom" style="height: calc(100% - 165px);">
			<div class="content-box">
				<div class="list-scroll-box scroll">
					<table class="tb-list-vertical" style="table-layout: fixed;">
						<colgroup>
							<col width="12%">
							<col width="16%">
							<col width="16%">
							<col width="23%">
							<col width="23%">
							<col width="10%">
							<col width="10%">
						</colgroup>
						<thead>
							<th>참여자 번호</th>
							<th>참여자 이름</th>
							<th>데이터 분류</th>
							<th>측정 일시</th>
							<th>수신 일시</th>
							<th>상태</th>
							<th></th>
						</thead>
						<tbody>
							<template
								v-for="(patients) in collectList"
							>
								<tr
									:key="patients.id + '0'"
									@click.stop="doOpenData(patients)"
									:class="openList.indexOf(patients.id) >= 0 ? 'openTr' : ''"
								>
									<td>{{patients.id}}</td>
									<td>{{patients.name != '' ? patients.name : '-'}}</td>
									<td>{{getDataTotal(patients)}}</td>
									<td>{{patients.recordDetailDate != '' ? patients.recordDetailDate.substring(0, 19) : '-'}}</td>
									<td>{{patients.updateDate != '' ? patients.updateDate.substring(0, 19) : '-'}}</td>
									<td><div class="status" :class="statusColor(patients.status)">{{getStatusType(patients.status)}}</div></td>
									<td @click.stop="openPage(patients)"><img :style="openList.indexOf(patients.id) >= 0 ? 'transform: rotate(180deg);' : ''" style="width: 11.9px; height: 7px;" src="@/assets/images/home/table_arrow.png" /></td>
								</tr>
								<tr
									:key="patients.id + 'sub'"
									v-if="openList.indexOf(patients.id) >= 0 && patients.dataList.length > 0"
								>
								<td colspan="7">
											<table class="tb-list-vertical sub-table" style="table-layout: fixed;">
												<colgroup>
													<col width="12%">
													<col width="16%">
													<col width="16%">
													<col width="23%">
													<col width="23%">
												</colgroup>
												<thead>
													<th>상태</th>
													<th>데이터 분류</th>
													<th>수치</th>
													<th>측정 일시</th>
													<th>수신 일시</th>
												</thead>
												<tbody>
													<template
														v-for="(data, dataIndex) in patients.dataList"
													>
														<tr
															:key="dataIndex"	
														>
															<td><div class="status" :class="statusColor(data.status)">{{getStatusType(data.status)}}</div></td>
															<td>{{getRecordType(data.recordType)}}</td>
															<td v-if="data.recordType != 'PROTEINURIA'">{{data.recordType == 'SLEEP_TIME' ? getSleepTime(data.value) : data.recordType == 'BLOOD_PRESSURE' ? data.value + '/' + data.subValue : data.value}}</td>
															<td v-if="data.recordType == 'PROTEINURIA'">
																<span v-if="data.value == 1">0 mg/L</span>
																<span v-if="data.value == 2">15-30 mg/L</span>
																<span v-if="data.value == 3">30 mg/L</span>
																<span v-if="data.value == 4">100 mg/L</span>
																<span v-if="data.value == 5">300 mg/L</span>
																<span v-if="data.value == 6">1000 mg/L 이상</span>
															</td>
															<td>{{data.recordDetailDate.substring(0, 19)}}</td>
															<td>{{data.updateDate.substring(0, 19)}}</td>
														</tr>
													</template>
												</tbody>
											</table>
										</td>
									</tr>
							</template>
							<tr v-if="collectList.length == 0">
								<td colspan="7" class="no-list">
									데이터가 존재하지 않습니다.
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="pagination-wrap">
					<pagination
						:data="pagination"
						:show-disabled="true"
						:limit="4"
						@pagination-change-page="doSearchPage"
					>
						<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
						<button type="button" slot="next-nav" class="page-next">&gt;</button>
					</pagination>
				</div>
			</div>
		</div>
		<CollectDataPopup v-if="isCollectDataPopup" :collectData="collectData" />
	</div>
</template>

<script>
import Vue from "vue";
import VeeValidator from "vee-validate";
import EventBus from "@/script/EventBus.js";
import DatePicker from 'vue2-datepicker';
import CollectDataPopup from "@/components/collectData/CollectDataPopup.vue";
import axios from "axios";
Vue.use(VeeValidator);

export default {
	name: "CollectDataList",
	created() {
		this.logger.debug(this, ".created()");
		console.log(this.userInfo.userId);
		this.selectCollectList();
	},
	mounted() {
		this.logger.debug(this, ".mounted()");
		this.nowDate();
		this.$nextTick(function () {
			if(this.$parent.current_page != "" && this.$parent.current_page != undefined){
				this.doSearchPage(this.$parent.current_page);
			}
		});
	},
	data() {
		return {
			items: {},
			isMode: 1,
			isCollectDataPopup: false,
			collectList: [],
			pagination: {},
			openList: [],
			collectData: {},
			searchText: "",
			searchCategory: "",
		};
	},
	components: {
		DatePicker,
		CollectDataPopup
	},
	watch: {
		searchText: function(val) {
			// this.item.pageName = val;
			this.items.searchText = val;
			this.items.pageNum = 1;
		},
		searchCategory: function(val) {
			// this.item.pageName = val;
			this.items.searchCategory = val;
			this.items.pageNum = 1;
		}
	},
	methods: {
		selectMode(code){
			if(code == 1){ this.isMode = 1;}
			else{this.isMode = 2;}
		},
		keyupHandler(event) {
			this.logger.debug(this, "keyupHandler(event)");
			// this.searchTextVal = event.target.value;
			if (event.keyCode == 13)
			{
				EventBus.$emit("project-loading", true);
				this.selectCollectList();
			}
		},
		selectCollectList(){
			this.logger.debug(this, "selectCollectList()");
			this.openProjectIndex = -1;
			EventBus.$emit("project-loading", true);
			axios
				.post(this.config.contextRoot + "/collectData/selectCollectList.do", this.items)
				.then((response) => {
					console.log(response);
					this.collectList = response.data.collectList;
					this.pagination = response.data.pagination;

					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doSearchPage(page) {
			this.logger.debug(this, "doSearchPage()");
			if (typeof page === "undefined" || page === 0) {
				page = 1;
			}
			this.items.pageNum = page;
			this.selectCollectList();
		},
		nowDate(){
			const date = new Date();
			const year = date.getFullYear(); // YYYY
			const month = date.getMonth() + 1; // MM
			const day = date.getDate();	// DD
			const hours = date.getHours(); // HH
			const minutes = date.getMinutes(); // MM
			const seconds = date.getSeconds(); // ss
			const week = ['일', '월', '화', '수', '목', '금', '토'];
			setTimeout(function() {
                this.nowDate()
            }.bind(this), 1000);

			this.today = year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0') + ' (' + week[date.getDay()] + ') ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
		},
		getDateValue() {
			var informedConsentDtTemp = this.items.informedConsentDtTemp;
			var informedConsentDt = this.items.informedConsentDt;

			if(this.utils.isEmpty(informedConsentDtTemp))
			{
				if(this.utils.isEmpty(informedConsentDt))
				{
					return "YYYY-MM-DD"
				}
				else
				{
					return informedConsentDt;
				}
			}
			else
			{
				{
					this.$set(this.items, "informedConsentDt", informedConsentDtTemp);
				}
				return this.items.informedConsentDt;
			}
		},
		clearDate() {
			this.$set(this.items, "informedConsentDt", "");
			this.$set(this.items, "informedConsentDtTemp", "");
			setTimeout(function() {
				let popup = document.getElementsByClassName("mx-datepicker-popup")[0];
				popup.style.display = "none";
			}.bind(this), 0);
		},
		doOpenData(patients) {
			this.logger.debug(this, "doOpenData()");
			if(patients.dataList.length < 1){
				axios
						.post(this.config.contextRoot + "/home/selectData.do", patients)
						.then((response) => {
							console.log(response);
	
							patients.dataList = response.data.dataList;
							patients.managerList = response.data.managerList;
							this.isCollectDataPopup = true;
							this.collectData = patients;

						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
			}
			else{
				this.isCollectDataPopup = true;
				this.collectData = patients;
			}
		},
		todayCheck(recordDate){
			const rDate = recordDate.substring(0, 11);
			if(rDate == this.today.substring(0, 11)){
				return "오늘"
			}
			else{
				return ""
			}
		},
		openPage(patients) {
			this.logger.debug(this, "openPage()");
			if(patients.dataList.length < 1){
				axios
						.post(this.config.contextRoot + "/home/selectData.do", patients)
						.then((response) => {
							console.log(response);
	
							patients.dataList = response.data.dataList;
							patients.managerList = response.data.managerList;

						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
			}

			let id = patients.id;
			let index = this.openList.indexOf(id);

			if(index >= 0) this.openList.splice(index, 1);
			else this.openList.push(id);
		},
		statusColor(status){
			var result = "green";
			if(status == 'EMERGENCY'){
				result = 'red'
			}
			if(status == 'CAUTION'){
				result = 'yellow'
			}
			return result;
		},
		getRecordType(recordType){
			var result = "";

			if(recordType == 'WEIGHT'){
				result = '체중'
			}
			if(recordType == 'BLOOD_PRESSURE'){
				result = '혈압'
			}
			if(recordType == 'BLOOD_GLUCOSE'){
				result = '혈당'
			}
			if(recordType == 'HEART_RATE'){
				result = '심박수'
			}
			if(recordType == 'STEP_COUNT'){
				result = '걸음수'
			}
			if(recordType == 'CALORIE'){
				result = '칼로리'
			}
			if(recordType == 'PROTEINURIA'){
				result = '단백뇨'
			}
			if(recordType == 'OXYGEN_SATURATION'){
				result = '산소포화도'
			}
			if(recordType == 'STRESS'){
				result = '스트레스'
			}
			if(recordType == 'SLEEP_TIME'){
				result = '수면시간'
			}

			return result;
		},
		getStatusType(status){
			var result = "정상";
			if(status == 'EMERGENCY'){
				result = '경고'
			}
			if(status == 'CAUTION'){
				result = '주의'
			}
			return result;
		},
		getDataTotal(patients){
			var result = "";

			if(patients.insertCnt == 0){
				result = '0건';
			}
			else{
				result = '총 ' + (patients.insertCnt) + '건';
			}
			return result;
		},
		getSleepTime(ms){
			var hour = String(Math.floor((ms / (1000*60*60)) % 24)).padStart(2, "0");
			var min = String(Math.floor((ms / (1000*60)) % 60)).padStart(2, "0");
			var sec = String(Math.floor((ms / (1000)) % 60)).padStart(2, "0");
			return hour+':'+min+':'+sec;
		}
	},
};
</script>
<style>
@import '../../assets/css/login/login.css';
.home-background{
	width: 100%;
	height: 100%;
}
.home-title{
	width: 100%;
	height: 29px;
	display: flex;
    justify-content: space-between;
}
.title-left{
	display: flex;
    align-items: center;
    column-gap: 12px;
	font-size: 24px;
	font-weight: bold;
}
.title-right{
	display: flex;
    align-items: center;
	font-size: 14px;
	column-gap: 20px;
}
.warn-dot{
	width: 16px;
	height: 16px;
	border-radius: 50px;
}
.font-red{
	color: #F94848;
}
.red{
	background-color: #F94848;
}
.yellow{
	background-color: #FFAD09;
}
.green{
	background-color: #4BD985;
}
.warn-wrap{
	display: flex;
	align-items: center;
    column-gap: 4px;
}
.home-top{
	width: 100%;
	height: 180px;
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.home-bottom{
	width: 100%;
	height: calc(100% - 269px);
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.content-box{
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 0 10px 0px #ccc;
	background-color: #fff;
	position: relative;
}
.top-sub-title-red{
	width: 100%;
	height: 52px;
	background-color: #F94848;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.top-sub-title-green{
	width: 100%;
	height: 52px;
	background-color: #4BD985;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.count-dot{
	width: 8px;
	height: 8px;
	border: 1px solid #fff;
	border-radius: 50px;
}
.top-count{
	display: flex;
    column-gap: 5px;
	margin-right: 32px;
}
.white{
	background-color: #fff;
}
.none-content{
	width: 100%;
    height: calc(100% - 52px);
    display: flex;
    justify-content: center;
    align-items: center;
	font-size: 18px;
	color: #A9A9A9;
}
.left-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/left_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.right-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/right_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.name-tag{
	width: 44px;
	height: 22px;
	background-color: #EFEFEF;
	border-radius: 11px;
	font-size: 14px;
	color: #A9A9A9;
	display: flex;
    justify-content: center;
    align-items: center;
}
.data-zone{
	display: flex;
    justify-content: flex-start;
	align-items: center;
	column-gap: 10px;
	font-size: 16px;
	font-weight: bold;
}
.dot-line{
	height: 64px;
	border: 1px solid #DDDDDD;
	border-style: dashed;
}
.top-data{
	display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 4px;
}
.table-name{
	font-size: 20px;
	font-weight: bold;
	width: 100%;
	height: 60px;
	display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: 10px;
    padding-left: 32px;
}
.table-btn{
	width: 66px;
	height: 29px;
	border-radius: 15px;
	font-size: 16px;
	font-weight: 600;
	color: #6D6D6D;
}
.table-btn:hover{
	color: #FFF;
	background-color: #555555;
}
.btn-on{
	color: #FFF;
	background-color: #555555;
}
.list-select{
	width: 240px;
	height: 40px;
    padding: 0 15px;
    border: 1px solid #A9A9A9;
	border-radius: 5px;
    font-size: 10pt;
    color: #090909;
	
}
.search-content{
	display: flex;
    align-items: center;
	column-gap: 10px;
	margin: 25px 0;
	padding-bottom: 25px;
    border-bottom: 1px solid #BDC1C6;
}
.search-btn{
	min-width: 100px;
	height: 40px;
	border-radius: 5px;
	background-color: #555555;
	color: #fff;
	display: flex;
    justify-content: center;
    align-items: center;
	column-gap: 8px;
	cursor: pointer;
	font-size: 16px;
}
.search-btn:hover{
	background-color: #0176F9;
}
.search-btn > img{
	width: 13.5px;
	height: 14.5px;
}
.status{
	min-width: 55px;
	width: 55px;
	height: 22px;
	border-radius: 12px;
	color: #fff;
	font-size: 14px;
	display: flex;
	justify-content: center;
    align-items: center;
}
</style>
